import Vue from 'vue'
import dayjs from "dayjs"

Vue.prototype.dayjs = dayjs;

Vue.prototype.$global = {
    AppName: "",
    AppDesc: "",
    PageSize: 10,
    AppendixSize: 20 * 1024 * 1024,
    ImageSize: 1024 * 1024,
    // Html编码转义
    Html2Escape(v) {
        v = v.toString();
        v = v.replace(')![', ')\n![');
        return v.replace(/[<>&"`]/g, function (c) {
            return {
                '<': '&lt;',
                '>': '&gt;',
                '&': '&amp;',
                '"': '&quot;',
                '`': '&#x60;'
            }[c];
        });
    },
    MarkdownUnescape(v) {
        v = v.toString();
        v = v.replace(/&#0x60;/g, '`');
        v = v.replace(/&#0x27;/g, "'");
        v = v.replace(/&#0x22;/g, '"');
        v = v.replace(/&#0x0A;/g, '\n');
        v = v.replace(/&#0x0D;/g, '\r');
        v = v.replace(/&#0x5C;/g, '\\');
        v = v.replace(/&amp;/g, '&');
        return v;
    },
    Get(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return 'null';
    }
};
